import * as React from "react";

const SvgArrowLeft = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path d="M22.0797 12H1.92029M1.92029 12L11.1617 2.75856M1.92029 12L11.1617 21.2414" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" /></svg>;

export default SvgArrowLeft;